<template>
  <div>
    <fccTable
      striped
      hover
      :fields="fields"
      responsive
      :porPage="itemPorPage"
      search
      pagination
      :titlePage="titlePage"
      titlePDF="Controle de versionamento"
      :actions="actions"
      :optionsButton="optionsButton"
      :items="listagemVersion"
    >
    </fccTable>
    <fccModal
      centered
      idModal="viewVersionModal"
      size="lg"
      :titleModal="titleModal"
      escondeFooter
      travaEsc
      travaBack
    >
      <div>
        Versão: <strong>{{ adicionarVersao.versao }}</strong>
      </div>
      <div v-html="adicionarVersao.descricaocontrole"></div>
    </fccModal>
    <fccModal
      centered
      idModal="editVersionModal"
      size="lg"
      :titleModal="titleModal"
      escondeFooter
      travaEsc
      travaBack
    >
      <form autocomplete="off" @submit.prevent="adicionarTVersao">
        <div class="row">
          <div class="col-sm-4">
            <fccInput extraClasses="inputLabel" required v-model="adicionarVersao.versao"
              >Versão</fccInput
            >
          </div>
        </div>
        <div class="row innerPage">
          <div class="col-sm-12">
            <label class="ml-j">Descrição</label>
            <b-form-textarea
              placeholder="Digite a descrição..."
              rows="3"
              v-model="adicionarVersao.descricaocontrole"
              :state="
                adicionarVersao.descricaocontrole != null &&
                adicionarVersao.descricaocontrole.length >= 5 &&
                adicionarVersao.descricaocontrole.length <= 500
              "
              required
            />
          </div>
        </div>
        <div class="row innerPage">
          <div class="col-sm-12 text-right">
            <fccButton classeAdd="form-control" tipo="submit">{{ labelsSystem.salvar }}</fccButton>
          </div>
        </div>
      </form>
    </fccModal>
  </div>
</template>


<script lang="js">
import axios from 'axios'
import store from '../../store';
export default {
  data() {
    return {
       itemPorPage: 50,
       fields: [
        { key: 'idcontrole', label: 'Código', sortable: true },
        { key: 'versao', label: 'Versão', sortable: true },
       
        { key: 'actions', label: '', tdClass: 'no-print', thClass: 'no-print' }
      ],
      actions: [
        {
          button: true,
          funcaoButton: 'viewVersion',
          icon: 'eye',
          tooltip: 'Visualizar',
          objpermCodigo: store.state.permissaoMenu.editar
        },
      ],
      sortBy: 'ordem',
      titlePage: 'Ordenando Menu Principal',
      titleModal: 'Controle de Versão',
      adicionarVersao: {},
      listaObjetos: {},
      menu: {},
      objparent: '',
      listagemVersion: [],
      optionsButton: [
        {
          funcaoButton: 'addField',
          tooltip: 'Adicionar',
          icon: 'plus',
          objpermCodigo: store.state.permissaoMenu.adicionar
        }
      ],
      objetoReserva: []
    }
  },
  props: {
    appId: {
        type: Number,
        required: true
    }
  },
  methods: {
    adicionarTVersao() {
        this.carregaTexto(this.codeMensagem('C01'))
      axios
        .post(
          this.baseUrlSeguranca + 'TbControleVersaoSistema/Incluir',
          this.adicionarVersao,
          this.dadosLoginSession.fccTokenHeaders
        )
        .then(() => {
          this.adicionarVersao = {}
          this.callToast(this.mensagensUpdate.editado, 'success')
          this.$root.$emit('bv::hide::modal', 'editVersionModal')
          this.listagemVersionamento()
        })
        .catch((error) => {
          this.setErrorSystem(error)
        })
        .finally(this.carregaTexto())
    },
    viewVersion(_, viewVersionModal) {
        this.adicionarVersao = {...viewVersionModal}
        this.$root.$emit('bv::show::modal', 'viewVersionModal')
    },
    addField() {
        this.adicionarVersao = {
            idcontrole: 0,
            appid: this.appId,
            descricaocontrole: "",
            cdfuncionario: this.dadosUserSession.usuCdFuncionario,
            versao: null
        }
        this.$root.$emit('bv::show::modal', 'editVersionModal')
    },
    listagemVersionamento() {
      this.carregaTexto(this.codeMensagem('C01'))
      axios
        .get(
          this.baseUrlSeguranca + 'TbControleVersaoSistema/ListarPorAppId/' + this.appId,
          this.dadosLoginSession.fccTokenHeaders
        )
        .then((response) => {
          this.listagemVersion = response.data
          this.carregaTexto()
        })
        .catch((error) => {
          this.carregaTexto()
          this.setErrorSystem(error)
        })
    }
  },
  mounted() {
    this.baseUrlSeguranca = this.$fccStore.state.baseUrlSeguranca
    this.listagemVersionamento()
  }
}
</script>
